/*
* Copyright (C) Regione Lombardia
*/
export enum PermessiEnum {
    OPERA_EDIT = 'OPERA_EDIT',
    OPERA_DELETE = 'OPERA_DELETE',
    OPERA_WORKFLOW_NEXT = 'OPERA_WORKFLOW_NEXT',
    OPERA_EXPORT_SINTESI_OPERA = 'OPERA_EXPORT_SINTESI_OPERA',
    OPERA_EXPORT_ELABORAZIONE_TERRITORIO = 'OPERA_EXPORT_ELABORAZIONE_TERRITORIO',
    OPERA_EXPORT_CONFRONTO_SOGGETTI_TERRITORIALI = 'OPERA_EXPORT_CONFRONTO_SOGGETTI_TERRITORIALI',
    OPERA_CHANGE_ALL_STATO = 'OPERA_CHANGE_ALL_STATO',

    PROGETTO_CREATE = 'PROGETTO_CREATE',
}
